import React from 'react';
import { Box } from '@mui/material';
import IconWithStackedText from '../LoadingStates';

const renderCenteredContent = (
  icon: React.ReactNode,
  title: string,
  subtitle: string
): JSX.Element => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      flexBasis: 'auto',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '32px',
      height: '100%',
      width: '100%',
      alignSelf: 'stretch',
      marginTop: 'auto',
      marginBottom: 'auto',
      textAlign: 'center'
    }}
  >
    <IconWithStackedText icon={icon} title={title} subtitle={subtitle} />
  </Box>
);

export default renderCenteredContent;
